import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  confirmText?: string;
  cancelText?: string;
  variant?:
    | 'link'
    | 'default'
    | 'destructive'
    | 'success'
    | 'outline'
    | 'outlineSuccess'
    | 'outlineDestructive'
    | 'secondary'
    | 'ghost';
  variantCancel?:
    | 'link'
    | 'default'
    | 'destructive'
    | 'success'
    | 'outline'
    | 'outlineSuccess'
    | 'outlineDestructive'
    | 'secondary'
    | 'ghost';
}

export function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  confirmText = 'Підтвердити',
  cancelText = 'Скасувати',
  variant = 'destructive',
  variantCancel = 'outline',
}: ConfirmationDialogProps) {
  const [clicked, setClicked] = useState(false);
  const handleConfirm = () => {
    setClicked(true);
    onConfirm();
  };
  useEffect(() => {
    if (isOpen) {
      setClicked(false);
    }
  }, [isOpen]);
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="w-full max-w-[420px] p-8 pb-7"
        aria-describedby={title}
      >
        <DialogHeader className="pb-2 pt-3">
          <DialogTitle className="text-center text-2xl">{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription hidden>{title}</DialogDescription>
        <DialogFooter className="flex gap-2">
          <Button variant={variant} onClick={handleConfirm} disabled={clicked}>
            {clicked ? 'працює...' : confirmText}
          </Button>
          <Button variant={variantCancel} onClick={onClose}>
            {cancelText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
